"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = void 0;
var utils_1 = require("@tiimiit/utils");
exports.actions = [
    {
        field: "edit",
        headerName: "Editar",
        sortable: false,
        width: 100,
        disableClickEventBubbling: true,
        renderCell: utils_1.RenderEditAction
    },
    {
        field: "delete",
        headerName: "Borrar",
        sortable: false,
        width: 100,
        disableClickEventBubbling: true,
        renderCell: utils_1.RenderDeleteAction
    }
];
/**
 * useTableHeaders is a table headers generator that return columns and rows
 *
 * @typeParam T entity to rows
 *
 *
 * ```typescript
 *
 * interface Test {
 *  name: string
 *  description: string
 * }
 *
 * const { columns, rows } = useTableHeaders<Test>({
 *  rows,
 *  enabledControls: true,
 *  widthFields: 250,
 *  editable: false
 * })
 *
 * ```
 */
var useTableHeaders = function (_a) {
    var rows = _a.rows, _b = _a.enabledControls, enabledControls = _b === void 0 ? false : _b, widthFields = _a.widthFields, editable = _a.editable;
    var getHeaders = function (data) {
        var getKeys = Object.keys(data[0]);
        var withControls = enabledControls ? exports.actions : [];
        return __spreadArray(__spreadArray([], __read(getKeys.map(function (v) { return ({ field: v, headerName: v, width: widthFields, editable: editable }); })), false), __read(withControls), false);
    };
    return { columns: getHeaders(rows), rows: rows };
};
exports.default = useTableHeaders;
//# sourceMappingURL=use-table-headers.js.map